module.exports = __webpack_public_path__ + "img/attached.0c4eaf3c.png";